import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useFlexESimulation(simId: string | null) {
  const { data: simulation, isLoading: simLoading } = useQuery({
    queryKey: ['flexe-simulation', simId],
    queryFn: async () => {
      if (!simId) return null;
      
      const { data, error } = await supabase
        .from('flexe_simulations')
        .select('*')
        .eq('id', simId)
        .single();
      
      if (error) throw error;
      return data;
    },
    enabled: !!simId
  });

  const { data: results, isLoading: resultsLoading } = useQuery({
    queryKey: ['flexe-results', simId],
    queryFn: async () => {
      if (!simId) return null;
      
      const { data, error } = await supabase
        .from('flexe_results_daily')
        .select('*')
        .eq('sim_id', simId)
        .order('date');
      
      if (error) throw error;
      return data;
    },
    enabled: !!simId
  });

  return {
    simulation,
    results,
    isLoading: simLoading || resultsLoading
  };
}
